/**
 * tab-shell — sygnał „jestem wewnątrz powłoki kart" dla komponentu `Layout`.
 *
 * Strony admina renderują własne `<Layout title=…>` (Sidebar + Topbar + main). W powłoce
 * kart chrome (Sidebar/Topbar/pasek kart) rysuje RAZ `AdminShell`, a panele kart renderują
 * tylko treść strony. Ten kontekst pozwala `Layout` wykryć, że jest w powłoce, i pominąć
 * własny Sidebar/Topbar (renderuje tylko `<main>`), żeby nie dublować chrome per karta.
 *
 * Domyślnie `false` — poza powłoką (np. testy, pełnoekranowe widoki) `Layout` działa jak dawniej.
 */

import { createContext, useContext } from 'react';

export const TabShellContext = createContext(false);

export function useInTabShell(): boolean {
  return useContext(TabShellContext);
}
